import i18n from '../i18nService';
import { propertiesStorage } from './propertiesStorage';

const resolveProperty = (propertyOrCode) => {
    if (propertyOrCode && typeof propertyOrCode === 'object') {
        const fromStorage = propertiesStorage.propertiesList.find(
            (it) => it.id === propertyOrCode.id || it.propertyName === propertyOrCode.propertyName,
        );
        return fromStorage ?? propertyOrCode;
    }
    if (typeof propertyOrCode === 'string') {
        return propertiesStorage.propertiesList.find((it) => it.propertyName === propertyOrCode);
    }
    return null;
};

const getNameFromProperty = (property, localeCode) => {
    if (property?.names?.length) {
        const found = property.names.find((it) => it.locale === localeCode);
        if (found?.name) {
            return found.name;
        }
    }
    return '';
};

export const propertyNamesService = {
    getLocalization(localeCode, propertyOrCode, withCodeReplace = false) {
        const property = resolveProperty(propertyOrCode);
        const code = property?.propertyName ?? (typeof propertyOrCode === 'string' ? propertyOrCode : '');
        const apiName = property ? getNameFromProperty(property, localeCode) : '';
        if (apiName) {
            return apiName;
        }
        return withCodeReplace ? code : '';
    },
    getPlaceholder(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.propertyItem.propertyName');
    },
};
